export const EMAIL_JS_SERVICE_ID = process.env
  .REACT_APP_EMAILJS_SERVICE_ID as string;
export const EMAIL_JS_TEMPLATE_ID = process.env
  .REACT_APP_EMAILJS_TEMPLATE_ID as string;
export const EMAIL_JS_PUBLIC_KEY = process.env
  .REACT_APP_EMAILJS_PUBLIC_K as string;

export const SANITY_DATASET = process.env.REACT_APP_SANITY_DATASET as string;
export const SANITY_PROJECT_ID = process.env
  .REACT_APP_SANITY_PROJECT_ID as string;
